import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import r from "../../core/Error.js";
import { JSONSupport as t } from "../../core/JSONSupport.js";
import { isSome as l } from "../../core/maybe.js";
import { setDeepValue as i } from "../../core/object.js";
import { property as s } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as o } from "../../core/accessorSupport/decorators/subclass.js";
import { read as c, write as u } from "../effects/jsonUtils.js";
import f from "./FeatureFilter.js";

var _d;

var n = _d = /*#__PURE__*/function (_t) {
  _inherits(d, _t);

  var _super = _createSuper(d);

  function d(e) {
    var _this;

    _classCallCheck(this, d);

    _this = _super.call(this, e), _this.filter = null, _this.includedEffect = null, _this.excludedEffect = null, _this.excludedLabelsVisible = !1;
    return _this;
  }

  _createClass(d, [{
    key: "write",
    value: function write(e, t) {
      var l = _get(_getPrototypeOf(d.prototype), "write", this).call(this, e, t);

      if (null != t && t.origin) {
        if (l.filter) {
          var _e = Object.keys(l.filter);

          var i;
          if (_e.length > 1 || "where" !== _e[0]) return null == (i = t.messages) || i.push(new r("web-document-write:unsupported-feature-effect", "Invalid feature effect 'filter'. A filter can only contain a 'where' property", {
            layer: t.layer,
            effect: this
          })), null;
        }

        var s;
        if ("showExcludedLabels" in l) return null == (s = t.messages) || s.push(new r("web-document-write:unsupported-feature-effect", "Invalid value for property 'excludedLabelsVisible' which should always be 'true'", {
          layer: t.layer,
          effect: this
        })), null;
      }

      return l;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _d({
        filter: l(this.filter) && this.filter.clone(),
        includedEffect: this.includedEffect,
        excludedEffect: this.excludedEffect,
        excludedLabelsVisible: this.excludedLabelsVisible
      });
    }
  }]);

  return d;
}(t);

e([s({
  type: f,
  json: {
    write: {
      allowNull: !0,
      writer: function writer(e, r, t, l) {
        var s = null == e ? void 0 : e.write({}, l);
        s && 0 !== Object.keys(s).length ? i(t, s, r) : i(t, null, r);
      }
    }
  }
})], n.prototype, "filter", void 0), e([s({
  json: {
    write: !0,
    origins: {
      "web-map": {
        read: {
          reader: c
        },
        write: {
          writer: u,
          overridePolicy: function overridePolicy() {
            return {
              allowNull: null != this.excludedEffect,
              isRequired: null == this.excludedEffect
            };
          }
        }
      }
    }
  }
})], n.prototype, "includedEffect", void 0), e([s({
  json: {
    write: !0,
    origins: {
      "web-map": {
        read: {
          reader: c
        },
        write: {
          writer: u,
          overridePolicy: function overridePolicy() {
            return {
              allowNull: null != this.includedEffect,
              isRequired: null == this.includedEffect
            };
          }
        }
      }
    }
  }
})], n.prototype, "excludedEffect", void 0), e([s({
  type: Boolean,
  json: {
    write: !0,
    name: "showExcludedLabels",
    origins: {
      "web-map": {
        name: "showExcludedLabels",
        default: !0
      }
    }
  }
})], n.prototype, "excludedLabelsVisible", void 0), n = _d = e([o("esri.layers.support.FeatureEffect")], n);
var a = n;
export { a as default };